import { CoveragesValuesType } from 'QuoteApp/components';
import { ServerRequestType, ServerRequestViaApplicationType } from './types';
import { ProductType } from '../GetDetails';

export const transformSaveCoveragesRequest = (
  values: CoveragesValuesType
): ServerRequestType => {
  return {
    coverages: {
      insurableItem: Object.keys(values.coverages.vehicles).flatMap(vehicleId =>
        Object.keys(values.coverages.vehicles[vehicleId]).map(coverageType => ({
          insurableItemIdentifier: vehicleId,
          coverageType,
          coverageLevelEnum: values.coverages.vehicles[vehicleId][coverageType],
        }))
      ),
      insuranceProduct: Object.keys(values.coverages.policy).map(
        coverageType => ({
          coverageType,
          coverageLevelEnum: values.coverages.policy[coverageType],
        })
      ),
    },
  };
};

export const transformSaveCoveragesRequestViaApplication = (
  values: CoveragesValuesType,
  productType: ProductType
): ServerRequestViaApplicationType => {
  return {
    insuranceProducts: [
      {
        productType,
        coverages: transformSaveCoveragesRequest(values).coverages,
      },
    ],
  };
};
